exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status[data-v-05a6e758] {\n  color: #aaa !important;\n  min-width: 90px;\n  text-align: center;\n  display: block;\n  line-height: 31px;\n  font-weight: 400;\n  padding: 0 10px;\n  cursor: pointer;\n}\n[data-v-05a6e758] .dropdown-menu {\n  top: -7px;\n  left: 105%;\n}\n[data-v-05a6e758] .dropdown-menu li {\n    cursor: pointer !important;\n}\n.custom-dropdown[data-v-05a6e758] {\n  display: inline-block;\n}\n.field-select[data-v-05a6e758] {\n  display: inline-block;\n  width: initial !important;\n  max-width: 200px !important;\n  margin-left: 10px;\n  margin-top: 5px;\n}\n", ""]);

// exports
